import { NpsIdentity, ReadOfficeDetailFromOrgService } from '~/constants/ff.posthog';
import PosthogService from './PosthogService';

export const getShouldReadOfficeDetailFromOrgService = (): boolean =>
  PosthogService.getInstance().isFeatureEnabled(ReadOfficeDetailFromOrgService);

export const getShouldUseNpsIdentity = (): boolean =>
  PosthogService.getInstance().isFeatureEnabled(NpsIdentity);
